import { render, staticRenderFns } from "./FarmerDetail.vue?vue&type=template&id=6b8e65b6"
import script from "./FarmerDetail.vue?vue&type=script&lang=js"
export * from "./FarmerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports